import { EntitetStatus } from "@dffedb/util";

import { DbNoteBilag } from "./db-note-bilag";

export interface DbNote {
    dato: string;
    henvendelsestype: string;
    id?: string;
    notebilag: DbNoteBilag[];
    notetekst: string;
    omraade: string;
    opfoelgdato: string;
    opfoelger: string;
    overskrift: string;
    status: EntitetStatus;
    tilstand: string;
    udfoertaf: string;
    udfoertdato: string;
}
